export default __webpack_public_path__ + "static/media/Group_7625.6369da1f.png";